import Stack from '@mui/material/Stack';

import AppDashboard from '../AppDashboard';
import NewLocationForm from '../../components/locations/NewLocationForm';

const NewFacilityPage = props => {
  return (
    <AppDashboard title='New Facility'>
      <Stack spacing={2}>
        <NewLocationForm />
      </Stack>
    </AppDashboard>
  )
};

export default NewFacilityPage;